<template>
  <div class="hidden">
    <p class="condition-label text-label">{{ $t('departure_datetime_condition') }}</p>
    <input :value="time" @change="onChange($event.target.value)" type="time" class="text-link is-condition">
  </div>
</template>

<script>
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  props: {
    value: {
      type: Object,
      default: function () {
        return '10:00'
      }
    }
  },
  computed: {
    time: function () {
      return this.value.format('HH:mm')
    }
  },
  methods: {
    onChange: function (time) {
      const profile = this.$store.getters['user/getProfile']
      if (time.length === 0) {
        this.time = this.default
      } else {
        const t = moment(profile.depDate + ' ' + time)
        this.$emit('input', t)
      }
    }
  }
}
</script>
